<ng-container *transloco="let t">
  <div ngbDropdown>
    <button ngbDropdownToggle type="button" class="nav-link dropdown-toggle btn btn-link" id="navbarDropdownMenuLink">
      {{ user().email }}
    </button>
    <div ngbDropdownMenu class="dropdown-menu user-menu">
      @if (user().hasGroup()) {
        <h6 class="dropdown-header">
          {{ user().getFirstGroup() }}
        </h6>
      }
      <button ngbDropdownItem id="logout" class="dropdown-item" type="button" (click)="logout()">
        {{ t('nav.log-out') }}
      </button>
    </div>
  </div>
</ng-container>
